<template>
  <a-modal
    :visible="true"
    title="修改活动环节"
    @ok="sub"
    @cancel="cancel"
    :width="600"
  >
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="环节标题">
        <a-input type="text" v-model="form.sec_name"></a-input>
      </a-form-item>
      <a-form-item label="自定义字段">
        <a-input
          style="width: 120px"
          type="text"
          v-model="form._key"
          placeholder="如主讲人"
        ></a-input>
        <a-input
          style="width: 300px; margin-left: 10px"
          type="text"
          v-model="form._val"
          placeholder="如主讲人姓名"
        ></a-input>
      </a-form-item>
      <a-form-item label="环节简介">
        <a-textarea
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="环节时间">
        <a-date-picker
          :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
          v-model="form.start_at"
        />
        <span style="margin: 0 10px">-</span>
        <a-date-picker
          :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }"
          v-model="form.end_at"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import moment from "moment";

export default {
  props: ['oldData'],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      form: {},
    };
  },
  created() {
    const oldData = { ...this.oldData };
    if(oldData.start_at){
      oldData.start_at = moment(oldData.start_at)
    }
    else{
      oldData.start_at = null
    }

    if(oldData.end_at) {
      oldData.end_at = moment(oldData.end_at)
    }
    else{
      oldData.end_at = null
    }

    this.form = oldData;
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/activity/section/update", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>